<template>
  <FaIcon
    :icon="ICON.ERROR"
    color="danger"
    :class="iconClass"
    :aria-label="label"
    v-tooltip="tooltip"
  />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';

interface Props {
  iconClass?: string;
  label?: string;
  tooltip?: string;
}

withDefaults(defineProps<Props>(), {
  iconClass: undefined,
  label: 'Error',
  tooltip: undefined
});
</script>

